import { harOpgavetype } from "./laes-opgavetype";

/** Dokumentnr fra `api/hentOpgaver` — matcher note-id i installationsnoter. */
export function udtraekOpgaveDokumentnr(data: unknown): Set<number> {
    if (!data || typeof data !== "object") {
        return new Set();
    }

    const opgaver = (data as { opgaver?: unknown }).opgaver;
    if (!Array.isArray(opgaver)) {
        return new Set();
    }

    const ids = opgaver.map((item) => laesDokumentnr(item)).filter((id): id is number => id != null);
    return new Set(ids);
}

export function laesDokumentnr(item: unknown): number | null {
    return laesPositivtTal(item, ["dokumentnr", "dokumentNr", "DokumentNr"]);
}

export function laesNoteListeItemId(item: unknown): number | null {
    return laesPositivtTal(item, ["id", "Id", "dokumentnr", "dokumentNr", "dokumentid", "dokumentId"]);
}

export function erNoteListeItemOpgave(item: unknown, opgaveDokumentnr: Set<number>): boolean {
    if (harOpgavetype(item)) {
        return true;
    }

    const id = laesNoteListeItemId(item);
    return id != null && opgaveDokumentnr.has(id);
}

function laesPositivtTal(item: unknown, keys: string[]): number | null {
    if (!item || typeof item !== "object") {
        return null;
    }

    const record = item as Record<string, unknown>;
    for (const key of keys) {
        const value = record[key];
        if (value === undefined || value === null || value === "") {
            continue;
        }

        const parsed = Number(value);
        if (Number.isFinite(parsed) && parsed !== 0) {
            return parsed;
        }
    }

    return null;
}
